function initTherapyAccordion() {
  const isMobile = window.innerWidth <= 768;
  const therapyItems = document.querySelectorAll(".therapy-item");

  therapyItems.forEach((item) => {
    const shortText = item.querySelector(".therapy-short");
    const fullText = item.querySelector(".therapy-full");
    const icon = item.querySelector(".arrow-icon");

    if (!shortText || !fullText || !icon) return;

    if (isMobile) {
      shortText.style.display = "block";
      fullText.style.display = "none";
      icon.style.transform = "rotate(0deg)";

      item.removeEventListener("click", handleClick);
      item.addEventListener("click", handleClick);
    } else {
      shortText.style.display = "none";
      fullText.style.display = "block";
      fullText.style.maxHeight = "none";
      fullText.style.opacity = "1";
      icon.style.transform = "rotate(0deg)";
    }
  });
}

function handleClick(event) {
  if (event.target.closest("a")) return;

  const parent = this;
  const shortText = parent.querySelector(".therapy-short");
  const fullText = parent.querySelector(".therapy-full");
  const icon = parent.querySelector(".arrow-icon");

  if (!shortText || !fullText || !icon) return;

  const isOpen = parent.classList.contains("open");

  document.querySelectorAll(".therapy-item").forEach((item) => {
    if (item !== parent) {
      item.classList.remove("open");
      item.querySelector(".therapy-short").style.display = "block";
      item.querySelector(".therapy-full").style.display = "none";
      item.querySelector(".arrow-icon").style.transform = "rotate(0deg)";
    }
  });

  if (!isOpen) {
    parent.classList.add("open");
    shortText.style.display = "none";
    fullText.style.display = "block";
    setTimeout(() => {
      fullText.style.maxHeight = fullText.scrollHeight + "px";
      fullText.style.opacity = "1";
    }, 10);
    icon.style.transform = "rotate(180deg)";
  } else {
    parent.classList.remove("open");
    fullText.style.maxHeight = null;
    fullText.style.opacity = "0";
    setTimeout(() => {
      fullText.style.display = "none";
      shortText.style.display = "block";
    }, 300);
    icon.style.transform = "rotate(0deg)";
  }
}

document.addEventListener("DOMContentLoaded", initTherapyAccordion);
window.addEventListener("resize", () => {
  clearTimeout(window.therapyResizeTimeout);
  window.therapyResizeTimeout = setTimeout(initTherapyAccordion, 300);
});
